import { MutationTree, GetterTree, ActionTree } from "vuex";

const state = () => ({
  token: ""
});

export type AuthState = ReturnType<typeof state>;

const getters: GetterTree<AuthState, any> = {
  isLogged(state) {
    return Boolean(state.token);
  },
  getToken(state) {
    return state.token;
  }
};

const mutations: MutationTree<AuthState> = {
  SET_TOKEN(state, data: { token: string }) {
    state.token = data.token;
  }
};

const actions: ActionTree<AuthState, any> = {
  logout({ commit, dispatch }) {
    commit("SET_TOKEN", { token: "" });
    this.$common.utils.app.removeAccountData({ dispatch });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
